import type {FC} from 'react';

import {imageWebFromImageWebSchema} from '@/modules/foundation/sanity/image/query';
import {internalLinkToHref} from '@/modules/foundation/sanity/link/query';

import type {SpecialProduct} from '../../components/product-list';
import ProductList from '../../components/product-list';

import {type ProductListAllFragment, productListFromProductListAllSection} from './query';

type Props = {
	data: ProductListAllFragment;
};

export const ProductListAllContainer: FC<Props> = ({data}) => {
	const products = productListFromProductListAllSection(data);

	const specialProducts: SpecialProduct[] = data.specialProducts.products.map((product) => ({
		_key: product._key,
		href: internalLinkToHref('page', product.slug),
		image: product.image ? imageWebFromImageWebSchema(product.image) : undefined,
		title: product.title ?? '',
	}));

	return (
		<ProductList
			products={products}
			spacingBottom={data.layout?.spacingBottom}
			spacingTop={data.layout?.spacingTop}
			specialProducts={specialProducts}
		/>
	);
};
